import { Component, OnInit } from "@angular/core";

import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ModalLayerComponent } from "../modal-layer/modal-layer.component";
import { LayerService } from "../../../home/services/layers/layer.service";
import { ModalCategoryComponent } from "../modal-category/modal-category.component";
import { CategoryService } from "../../../home/services/category_layers/category.service";
import { FormService } from "../../../home/services/forms/form.service";
import { AdmonActiveComponent } from "../modal_admon_active/admon-active/admon-active.component";
import { ModalFormsComponent } from "../modal-forms/modal-forms.component";
import { MapService } from "../../../view/services/map.service";
import { ModalFormUserComponent } from "../modal-form-user/modal-form-user.component";
import { ModalNewUserComponent } from "../modal-new-user/modal-new-user.component";
import { UsersService } from "../../services/users/users.service";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: "app-modal-window",
  templateUrl: "./modal-window.component.html",
  styleUrls: ["./modal-window.component.css"],
})
export class ModalWindowComponent implements OnInit {
  layersAdd: any;
  categoriesAdd: any;
  formsAdd: any;
  indexTab: number = 0;
  usersAdd: any;

  constructor(
    public mapService: MapService,
    public layerService: LayerService,
    public categoryService: CategoryService,
    public formService: FormService,
    protected dialog: MatDialog,
    public usersService: UsersService,
    private _snackBar: MatSnackBar

  ) {
    this.categoryService.getCategories().subscribe((data: {}) => {
      this.categoriesAdd = data;
    });

    this.layerService.getLayers().subscribe((data: {}) => {
      this.layersAdd = data;
    });

    this.formService.getForms().subscribe((data: {}) => {
      this.formsAdd = data;
    });

    this.getUsers();
  }

  ngOnInit() {}

  changeTab(index) {
    this.indexTab = index;
  }

  getUsers(){
    this.usersAdd = [];
    this.usersService.getUsers().subscribe((data: {}) => {
      this.usersAdd = data;
    });
  }

  createLayer() {
    this.dialog
      .open(ModalLayerComponent, { data: {} })
      .afterClosed()
      .subscribe((response) => {
        this.layerService.getLayers().subscribe((data: {}) => {
          this.layersAdd = data;
        });
      });
  }

  editLayer(id) {
    this.layerService.getLayer(id).subscribe((data: {}) => {
      this.dialog
        .open(ModalLayerComponent, { data: { data } })
        .afterClosed()
        .subscribe((response) => {
          this.layerService.getLayers().subscribe((data: {}) => {
            this.layersAdd = data;
          });
          this._snackBar.open("Se editó correctamente la capa", "OK", {
            duration: 5000,
          });
        });
    });
  }

  deleteLayer(id) {
    this.layerService.deleteLayer(id).subscribe((data: {}) => {
      this.layerService.getLayers().subscribe((data: {}) => {
        this.layersAdd = data;
      });
      this._snackBar.open("Se eliminó correctamente la capa", "OK", {
        duration: 5000,
      });
    });
  }

  createCategory() {
    this.dialog
      .open(ModalCategoryComponent, { data: {} })
      .afterClosed()
      .subscribe((response) => {
        this.categoryService.getCategories().subscribe((data: {}) => {
          this.categoriesAdd = data;
        });
      });
  }

  editCategory(id) {
    this.categoryService.getCategory(id).subscribe((data: {}) => {
      this.dialog
        .open(ModalCategoryComponent, { data: { data } })
        .afterClosed()
        .subscribe((response) => {
          this.categoryService.getCategories().subscribe((data: {}) => {
            this.categoriesAdd = data;
            this._snackBar.open("Se editó/eliminó correctamente la categoría", "OK", {
              duration: 5000,
            });
          });
        });
    });
  }

  createForm() {
    this.dialog
      .open(ModalFormsComponent, { data: {} })
      .afterClosed()
      .subscribe((response) => {
        this.formService.getForms().subscribe((data: {}) => {
          this.formsAdd = data;
        });
      });
  }

  editForm(id) {
    this.dialog
      .open(AdmonActiveComponent, { data: { id } })
      .afterClosed()
      .subscribe((response) => {
        /*this.categoryService.getCategories().subscribe((data: {}) => {
          this.categoriesAdd = data;
        });*/
      });
  }

  deleteForm(id) {
    this.formService.deleteForm(id).subscribe((data: {}) => {
      this.formService.getForms().subscribe((data: {}) => {
        this.formsAdd = data;
      });
      this._snackBar.open("Se eliminó correctamente el formulario", "OK", {
        duration: 5000,
      });
    });
  }

  getFormsUser(idUser) {
    this.formService.getFormsUser(idUser).subscribe((data: {}) => {
      this.dialog.open(ModalFormUserComponent, {
        data: { data, idUser },
        autoFocus: false,
      });
    });
  }

  openCreateUser(){
    const dialogRef = this.dialog.open(ModalNewUserComponent, {
      data: {edit: false},
        autoFocus: true,
      });
      dialogRef.afterClosed().subscribe(result => {
        this.getUsers();
      });
  }

  openEditUser(idUser){
    const dialogRef = this.dialog.open(ModalNewUserComponent, {
      data: {edit: true,
      idUser
      },
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getUsers();
    });
  }

  disableUser(idUser, username, lastname){
  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {message: "¿Desea inhabilitar este Usuario?",
      confirmAction: "Inhabilitar",
      message2: username + " " + lastname
      },
      autoFocus: true,
    });
     dialogRef.afterClosed().subscribe(result => {
       if (result) {
        const user = {
          usuario_realgisId: idUser 
        };
        this.usersService.disableUser(user).subscribe((data: {}) => {
          this._snackBar.open(data["SDTReporteErrores"][0]["Descipcion"], "OK", {
            duration: 5000,
          });
          this.getUsers();
        });
       }
    });

  }

  changeActuallyCategoryLayer(category, layer, form, formId) {
    this.mapService.setCurrentCategory(category);
    this.mapService.setCurrentLayer(layer);
    this.mapService.setCurrentForm(form);
    this.mapService.setCurrentFormId(formId);
  }
}
